/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import ServiceRegistry from "bundle/util/ServiceRegistry";
import IFrameMessageTypes from "common/constants/IFrameMessageTypes";
import messageExecutor from "app/core/MessageExecutor";

const isDomain = domain => domain && domain.toLowerCase().indexOf("http") === 0;

const extractDomain = url => {
    const anchor = document.createElement("a");
    anchor.href = url;
    return `${anchor.protocol}//${(anchor.host || anchor.href.match(/\/\/([^/]+)/)[1])}`;
};

class MessageReceiver {
    initialize() {
        this._targetDomain = "*";
        if ("referrer" in window.document && isDomain(window.document.referrer)) {
            try {
                this._targetDomain = extractDomain(window.document.referrer);
            } catch (e) {
                // Not logging anything here.
            }
        }
        ServiceRegistry.getService("LoggingService").logExternal("Core app boot up done.");
        ServiceRegistry.getService("MessagingService").initialize(
            this._sendMessage,
            this._messageReceived,
            window,
        );
        ServiceRegistry.getService("MessagingService").sendMessage(IFrameMessageTypes.READY, {});
    }

    _sendMessage = data => {
        window.parent.postMessage(data, this._targetDomain);
    };

    _messageReceived = (type, data) => {
        if (type === IFrameMessageTypes.INIT && isDomain(data.eventOrigin)) {
            this._targetDomain = data.eventOrigin;
        }
        messageExecutor.execute(type, data);
    }
}

const messageReceiver = new MessageReceiver();
export default messageReceiver;
